import React from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import Field from '../../common/FormField'
import AutoComplete from '../../common/AutoComplete'
import api from '../../../api'
import { statusCodes as retailerStatusCodes } from '../../../utils/retailer'

// The retailer is shown as "Name (email)". `label` is the store representative
// when one is set, falling back to the retailer name.
const retailerLabel = suggestion => suggestion.storeRep || suggestion.name || ''

const withEmail = (label, suggestion) =>
  suggestion.email ? `${label} (${suggestion.email})` : label

// Plain text — this becomes the input's value once a suggestion is picked, so
// the field reads the same as the dropdown entry.
const retailerDisplay = suggestion =>
  withEmail(retailerLabel(suggestion), suggestion)

// Searches the admin-only user list (GET /retailer/fetch_user) instead of the
// public Algolia `retailers` index: that index is queried with a key that
// ships in every frontend, so it no longer carries emails. Results are mapped
// onto the hit shape the select handlers read (objectID, createdDay, name).
const searchRetailers = (query, callback) => {
  const term = (query || '').trim()
  if (term.length < 2) {
    callback([])
    return
  }
  api.searchRetailers(term).then(
    collection =>
      callback(
        collection
          .toJSON()
          .map(({ attributes }) => attributes)
          // A deleted seller must not be attachable to an item.
          .filter(
            attributes =>
              attributes.statusCode !== retailerStatusCodes.DELETED.value
          )
          .map(attributes => ({
            objectID: attributes.uuid,
            createdDay: attributes.createdDay,
            name: attributes.name,
            storeRep: attributes.storeRep,
            email: attributes.email
          }))
      ),
    () => callback([])
  )
}

export default ({ data, onSelect, disabled, error }) =>
  <Field
    type="input"
    name="Existing Retailer *"
    note={
      <span>
        If retailer does not exist,{' '}
        <Link to="/retailers/new">Create a New Retailer</Link>
      </span>
    }
    error={error.retailer}
  >
    <AutoComplete
      datasets={{
        source: searchRetailers,
        // A function so the selected suggestion fills the input with
        // "Name (email)" instead of just the bare retailer name.
        displayKey: retailerDisplay,
        templates: {
          // Rendered as HTML, and names and emails are user-chosen.
          suggestion: suggestion => _.escape(retailerDisplay(suggestion))
        }
      }}
      handleSelect={(event, suggestion) => {
        onSelect(suggestion)
      }}
      initialValue={data.retailerName}
      disabled={disabled}
    />
  </Field>
